import React, { useState } from "react";
import "../styles/Filters.css";
import Select from "./Select";

const UserFilterDropdown = ({
  options = [],
  filterName = "assigneeFilter",
  searchFilters,
  setSearchFilters,
  closeFilter,
  columnName = "User",
  alignRight = false,
  setWrapperRef,
  isMulti = true,
}) => {
  // Extract current value from searchFilters
  const rawValue = searchFilters?.[filterName]?.value;
  const initialValues = Array.isArray(rawValue)
    ? rawValue
    : rawValue !== undefined && rawValue !== null && rawValue !== ""
    ? [rawValue]
    : [];

  // Normalize options to ensure valid { label, value, image, showIcon } array with username string values
  const formattedOptions = (options || []).map((opt) => {
    const textLabel =
      (typeof opt?.labelKey === "string" && opt.labelKey.trim()) ||
      (typeof opt?.label === "string" && opt.label.trim()) ||
      opt?.username ||
      opt?.name ||
      "";
    return {
      label: textLabel,
      value: textLabel,
      image: opt?.image,
      showIcon: true,
    };
  });

  // Find currently selected options
  const initialSelected = formattedOptions.filter((opt) =>
    initialValues.some((v) => String(v).toLowerCase() === String(opt.value).toLowerCase())
  );

  const [selectedOptions, setSelectedOptions] = useState(initialSelected);

  const handleApply = () => {
    if (!selectedOptions || selectedOptions.length === 0) {
      setSearchFilters((prev = {}) => {
        const updated = { ...prev };
        delete updated[filterName];
        return updated;
      });
    } else {
      const selectedValues = selectedOptions.map((opt) => opt.value);
      setSearchFilters((prev = {}) => ({
        ...prev,
        [filterName]: {
          filter_type: isMulti ? "one_of" : "equals",
          value: isMulti ? selectedValues : selectedValues[0],
        },
      }));
    }
    if (closeFilter) closeFilter();
  };

  return (
    <div
      className={`filter_wrapper${alignRight ? " filter_wrapper_align_right" : ""}`}
      ref={setWrapperRef}
    >
      <Select
        label={`Select ${columnName}`}
        placeholder="Search..."
        options={formattedOptions}
        value={isMulti ? selectedOptions : selectedOptions[0] || null}
        onChange={(opts) => {
          if (isMulti) {
            setSelectedOptions(opts || []);
          } else {
            setSelectedOptions(opts ? [opts] : []);
          }
        }}
        isMulti={isMulti}
        isSearch={true}
      />
      <div className="filter_buttons mt-3">
        <button type="button" onClick={closeFilter} className="btn-cancel">
          Cancel
        </button>
        <button type="button" onClick={handleApply} className="btn-apply">
          Apply
        </button>
      </div>
    </div>
  );
};

export default UserFilterDropdown;
